export const HOME_PATH = '/';
export const CASES_PATH = 'cases';
export const EVENT_PATH = 'event';
export const ASSET_PATH = 'asset';
export const LOGIN_PATH = 'login';
export const MODEL_PATH = 'models';

export const HOME_PAGE = HOME_PATH;
export const CASES_PAGE = (caseId: string | number) => `/${CASES_PATH}/edit/${caseId}`;
export const EVENT_PAGE = (eventId: string | number) => `/${EVENT_PATH}/${eventId}`;
export const EVENTS_PAGE_LIST = `/events`;
export const ASSET_PAGE = (assetId?: string | number, tab?: string) =>
  assetId ? `/${ASSET_PATH}/${assetId}/${tab || ''}` : `/${ASSET_PATH}/${tab || ''}`;

export const MODEL_PAGE = (modelName?: string, assetId?: string | number) =>
  `/${MODEL_PATH}/${assetId}/${modelName}`;
export const LOGIN_PAGE = `/${LOGIN_PATH}`;
// dynamic content: https://reactrouter.com/en/main/hooks/use-navigate
export const PREVIOUS_PAGE = -1;
export const CASES_PAGE_LIST = (statusTab?: string) =>
  statusTab ? `/cases/${statusTab}` : `/cases`;
export const CASES_PAGE_CREATE = `${CASES_PAGE_LIST()}/create`;

export const PDF_PAGE = (assetId: string | number, month: number | string, year: number | string) =>
  `/${ASSET_PATH}/${assetId}/reports/pdf/${month}/${year}`;
